import React from "react";
import { Viewer, Worker } from "@react-pdf-viewer/core";
import "@react-pdf-viewer/core/lib/styles/index.css";
import { Box, Button, Typography } from "@mui/material";
import { useState } from "react";
import SRSIconButton from "../buttons/SRSIconButton";
import validateDocument from "../api/folder/validateDocument";
import { getOrRefreshFirebaseToken } from "../config/getFirebaseToken";
import refuseFolder from "../api/folder/refuseFolder";
import PrimaryButton from "../buttons/PrimaryButton";
import { TruncatedString } from "../models/DataFunctions";
import SecondaryButton from "../buttons/SecondaryButton";
import { BackgroundColor } from "devextreme-react/cjs/chart";
import Icon1 from "../icons/Icon";
import downloadMultiPDF from "../api/download/downloadMultiPDF";
import { name } from "dayjs/locale/fr";
import downloadFile from "../api/download/downloadFile";

// Worker URL should match the version of the pdfjs-dist package
const workerUrl =
  "https://unpkg.com/pdfjs-dist@3.11.174/build/pdf.worker.min.js";

const PDF = ({
  files = [],
  onClose,
  defaultScale = 1.3,
  can_download = false,
}) => {
  const [selectedPdf, setSelectedPdf] = useState(files && files[0]);

  function isImage(file) {
    return (
      file.includes(".jpeg") || file.includes(".jpg") || file.includes(".png")
    );
  }

  function isPDF(file) {
    return file.includes(".pdf") || file.includes(".PDF");
  }

  // Refresh the PDF URLs

  return (
    <div className="flex relative flex-row w-full h-full justify-between rounded-xl p-2">
      {can_download && (
        <div className="absolute top-2 right-2">
          <SecondaryButton
            onClick={() => downloadFile(files[0], "Facture.pdf")}
          >
            Télécharger
          </SecondaryButton>
        </div>
      )}

      {/* PDF Buttons Section */}
      <div className="flex flex-col w-full gap-2">
        <div className="flex flex-wrap space-x-1 space-y-1">
          {files.filter((file) => file?.url).length > 1 &&
            files
              .filter((file) => file?.url)
              .map((file, index) =>
                selectedPdf?.url === file?.url ? (
                  <PrimaryButton
                    key={index}
                    variant="contained"
                    onClick={() => setSelectedPdf(file)}
                  >
                    PDF {TruncatedString(file?.name, 20)}
                  </PrimaryButton>
                ) : (
                  <SecondaryButton
                    key={index}
                    className={"w-fit "}
                    variant="contained"
                    onClick={() => setSelectedPdf(file)}
                  >
                    PDF {TruncatedString(file?.name, 20)}
                  </SecondaryButton>
                )
              )}
        </div>

        {/* Full PDF Viewer Section */}
        <div className="flex flex-col w-full h-full overflow-auto">
          {selectedPdf?.url && isPDF(selectedPdf?.url) && (
            <iframe
              src={selectedPdf?.url}
              className="w-full h-fit rounded-xl hide-scrollbar overflow-hidden "
              style={{
                border: "none",
                height: "calc(100vh - 300px)", // Ensure the viewer is scrollable
              }}
              title="PDF Viewer"
            ></iframe>
            // <Worker workerUrl="https://unpkg.com/pdfjs-dist@3.11.174/build/pdf.worker.min.js">
            //   <Box
            //     sx={{
            //       backgroundColor: "transparent",
            //       height: "calc(100vh - 300px)", // Ensure the viewer is scrollable
            //       overflow: "auto", // Make the PDF viewer itself scrollable
            //       touchAction: "manipulation", // allows pinch and scroll
            //       WebkitOverflowScrolling: "touch", // smooth scrolling on iOS
            //     }}
            //   >
            //     {/* Render the selected PDF */}
            //     <Viewer
            //       fileUrl={selectedPdf?.url}
            //       defaultScale={defaultScale}
            //     />
            //   </Box>
            // </Worker>
          )}
          {selectedPdf?.url && isImage(selectedPdf?.url) && (
            <div
              className="flex flex-col gap-2 overflow-auto"
              style={{
                height: "calc(100vh - 300px)",
              }}
            >
              <img
                src={selectedPdf?.url}
                className=" max-h-full w-full object-contain rounded-xl"
              ></img>
            </div>
          )}
          {selectedPdf?.url &&
            !isPDF(selectedPdf?.url) &&
            !isImage(selectedPdf?.url) && (
              <div
                className="flex flex-col gap-2 overflow-auto"
                style={{
                  height: "calc(100vh - 300px)",
                }}
              >
                <div className="text-h1 text-shadow_50 h-full w-full items-center justify-center flex flex-col gap-2">
                  <Icon1
                    icon_name="warning"
                    height="30px"
                    width="30px"
                    fill="grey"
                  />
                  Ce document n'est pas visualisable (Fichier .zip, .xml, .docx,
                  .jpeg, .png, etc.)
                </div>
              </div>
            )}
        </div>
      </div>

      {/* Actions Sidebar */}
    </div>
  );
};

export default PDF;
